import { CommonComponent, LayoutSetting } from "../types";
import { ApiInstance } from "./instance";

export class CommonApi extends ApiInstance {
  constructor(locale = "id-ID") {
    super(locale);
  }

  async getLayoutSetting() {
    const query = {
      populate: {
        header: {
          populate: [
            "logo",
          ],
        },
        headerNavigation: {
          on: {
            [CommonComponent.HrefLink]: {
              populate: [
                "icon"
              ]
            },
            [CommonComponent.LinkList]: {
              populate: [
                "list",
                "list.icon"
              ]
            }
          }
        },
        sidebarNavigation: {
          on: {
            [CommonComponent.SidebarMainNavigation]: {
              populate: [
                "list",
                "list.icon"
              ]
            },
            [CommonComponent.SidebarOtherNavigation]: {
              populate: [
                "list",
                "list.icon"
              ]
            }
          }
        },
        userPopupNavigation: {
          on: {
            [CommonComponent.HrefLink]: {
              populate: [
                "icon"
              ]
            },
            [CommonComponent.LinkList]: {
              populate: [
                "list",
                "list.icon"
              ]
            }
          }
        },
        footer: {
          populate: [
            "cta",
            "cta.links",
            "cta.links.icon",
            "navigations",
            "navigations.icon",
            "footerContents",
            "footerContents.socials",
            "footerContents.socials.icon",
            "footerContents.contacts",
            "footerContents.contacts.list",
            "footerContents.contacts.list.icon",
            "logos",
            "logos.icon"
          ],
        },
        features: {
          populate: [
            "popUp",
            "popUp.image",
            "popUp.link",
            "popUp.link.icon"
          ],
        },
      },
    };

    return this._SendWithQuery<LayoutSetting>("/layout-setting", query);
  }
}
